module.exports = __webpack_public_path__ + "img/31.87267868.jpg";